import { CheckIcon, TriangleAlertIcon } from "lucide-react";
import { toast } from "react-toastify";

const successStyle = {
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid #457E89",
  fontSize: 14,
  display: "flex",
  alignItems: "center",
};

export const toastSuccessPositionCenter = (message: string) => {
  toast(<MessageNoTitle message={message} type="success" />, {
    position: "bottom-center",
    style: successStyle,
    closeOnClick: true,
  });
};

const errorStyle = {
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid #FFA39E",
  fontSize: 14,
};

export const toastErrorPositionCenter = (message: string) => {
  toast(<MessageNoTitle message={message} type="error" />, {
    position: "bottom-center",
    style: errorStyle,
    closeOnClick: true,
  });
};

const MessageNoTitle = ({
  message,
  type,
}: {
  message: string;
  type: string;
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      paddingLeft: 4,
      paddingTop: 4,
    }}
  >
    {type === "error" && (
      <TriangleAlertIcon style={{ marginRight: 12, color: "#F5222D" }} />
    )}
    {type === "success" && (
      <CheckIcon style={{ marginRight: 12, color: "#457E89" }} />
    )}
    <div>{message}</div>
  </div>
);
